import React from "react";

const ScanSettings = ({
  setScanType,
  isCameraScan,
  setScanMode,
  isManualMode,
  isStockModel,
}) => {
  return (
    <div className="d-flex">
      <div onChange={setScanType}>
        <h6>Scan Type</h6>
        <div>
          <input
            type="radio"
            value="handledScanner"
            checked={!isCameraScan}
            className="mr-1"
            id="handledScanner"
          />
          <label htmlFor="handledScanner"> Handheld scanner </label>
        </div>
        <div className="align-items-left">
          <input
            type="radio"
            value="cameraScanner"
            checked={isCameraScan}
            className="mr-1"
            id="cameraScanner"
          />
          <label htmlFor="cameraScanner"> Device Camera </label>
        </div>
      </div>

      {isStockModel &&
        <div onChange={setScanMode} className="col-2">
          <h6>Scan Mode</h6>
          <div>
            <input
              type="radio"
              value=""
              checked={!isManualMode}
              className="mr-1"
              id="incrementMode"
            />
            <label htmlFor="incrementMode"> Increment Mode </label>
          </div>
          <div>
            <input
              type="radio"
              value="manualMode"
              checked={isManualMode}
              className="mr-1"
              id="manualMode"
            />
            <label htmlFor="manualMode"> Manual Mode </label>
          </div>
        </div>
      }
    </div>
  );
};

export default React.memo(ScanSettings);
